/**
 * @generated SignedSource<<d3cfa7cd94bc6cf751a411d84f6e648c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftDraftItemTile_nftItemDraft$data = {
  readonly editionNumber: number | null;
  readonly editionTotal: number | null;
  readonly name: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftDraftItemTileDetails_nftItemDraft" | "NftDraftItemTileMedia_nftItemDraft">;
  readonly " $fragmentType": "NftDraftItemTile_nftItemDraft";
};
export type NftDraftItemTile_nftItemDraft$key = {
  readonly " $data"?: NftDraftItemTile_nftItemDraft$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftDraftItemTile_nftItemDraft">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftDraftItemTile_nftItemDraft",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editionNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editionTotal",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftDraftItemTileMedia_nftItemDraft"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftDraftItemTileDetails_nftItemDraft"
    }
  ],
  "type": "NftItemDraft",
  "abstractKey": null
};

(node as any).hash = "070807df2451e4c5045d9098b7b4b303";

export default node;
